// extracted by mini-css-extract-plugin
export default {"grid":"Grid_grid__2C66e","grid-2":"Grid_grid-2__TMhhQ","grid-3":"Grid_grid-3__VWyyq"};